import consumer from "./consumer"

consumer.subscriptions.create("NotificationChannel", {
  received(data) {
    // ---- send-command-button disable/enable ----
    const button = document.querySelector(".send-command-button")

    if (button && Object.prototype.hasOwnProperty.call(data, "job_running")) {
      button.disabled = data.job_running
    }

    // ---- flash notifs. ----
    const flashRoot = document.getElementById("flash-cms-messages")
    if (!flashRoot) return

    const flashContainer = flashRoot.querySelector(".flash-cms-container")
    if (!flashContainer) return

    if (data.message) {
      const messageDiv = document.createElement("div")

      // ---- add base animation class + flash-type-specific class ----
      const flashClass =
        data.flash_type === "notice" ? "flash-notice" : "flash-alert"

      messageDiv.classList.add("flash-message", flashClass)
      messageDiv.textContent = data.message

      // ---- add close button ----
      const closeBtn = document.createElement("button")
      closeBtn.classList.add("flash-close")
      closeBtn.innerHTML = "&times;"
      closeBtn.onclick = () => messageDiv.remove()
      messageDiv.appendChild(closeBtn)

      flashContainer.appendChild(messageDiv)

      // ---- auto-remove notices ----
      if (data.flash_type === "notice") {
        setTimeout(() => messageDiv.classList.add("fade-out"), 13000)
        setTimeout(() => messageDiv.remove(), 15000)
      }
    }
  }
})
